export default __webpack_public_path__ + "static/media/Head_4_Ear_3_C1.f4ca1811.svg";